/** 출력 포맷 모음 */
import type { StitchPlan } from "../engine/plan";
import { writeDst } from "./dst";
import { writeExp } from "./exp";
import { writeJef } from "./jef";
import { writePes } from "./pes";

export type FormatId = "dst" | "pes" | "jef" | "exp";

export const FORMATS: { id: FormatId; ext: string; name: string; machines: string }[] = [
  { id: "dst", ext: "dst", name: "DST", machines: "타지마·썬스타·대부분의 공업용 자수기" },
  { id: "pes", ext: "pes", name: "PES", machines: "부라더(Brother)·베르니나 가정용" },
  { id: "jef", ext: "jef", name: "JEF", machines: "자노메(Janome)·엘나" },
  { id: "exp", ext: "exp", name: "EXP", machines: "멜코(Melco)·베르니나" },
];

export function encodePlan(plan: StitchPlan, format: FormatId, name: string): Uint8Array {
  switch (format) {
    case "dst":
      return writeDst(plan, name);
    case "pes":
      return writePes(plan, name);
    case "jef":
      return writeJef(plan);
    case "exp":
      return writeExp(plan);
  }
}

export { writeDst, writeExp, writeJef, writePes };
export { readDst } from "./dst";
export { makeZip } from "./zip";
